<div class="container">
  <div class="video-container">
    <img *ngIf="video.src && !video.loading && !errorOccurred" id="play-icon" src="assets/icons/play_icon.svg" alt=""/>
    <img *ngIf="video.loading" src="assets/img/videoPlaceholder.png" [style.object-fit]="objectFit">
    <!-- <mat-icon id="error-icon" *ngIf="errorOccurred">error</mat-icon> -->
    <i *ngIf="errorOccurred" class="fa-light fa-circle-exclamation"></i>
      <vg-player class="flex-1">
        <video
        #vid [vgMedia]="$any(vid)"
        (canplay)="setCanPlay($event)"
        (error)="error()"
        [vgHls]="video.src"
        id="singleVideo1"
        ></video>
      </vg-player>
  </div>
</div>
